type StorageType = "local" | "session";

type StorageWrapper = {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
  clear: () => void;
};

const resolveStorage = (type: StorageType): Storage | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const storage =
      type === "local" ? window.localStorage : window.sessionStorage;
    return storage;
  } catch {
    return null;
  }
};

const createStorageWrapper = (type: StorageType): StorageWrapper => ({
  getItem: (key: string) => {
    const storage = resolveStorage(type);
    if (!storage) {
      return null;
    }
    try {
      return storage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: string) => {
    const storage = resolveStorage(type);
    if (!storage) {
      return;
    }
    try {
      storage.setItem(key, value);
    } catch {
      // no-op
    }
  },
  removeItem: (key: string) => {
    const storage = resolveStorage(type);
    if (!storage) {
      return;
    }
    try {
      storage.removeItem(key);
    } catch {
      // no-op
    }
  },
  clear: () => {
    const storage = resolveStorage(type);
    if (!storage) {
      return;
    }
    try {
      storage.clear();
    } catch {
      // no-op
    }
  },
});

export const safeLocalStorage = createStorageWrapper("local");

export const safeSessionStorage = createStorageWrapper("session");
